import React from 'react'
import PropTypes from 'prop-types'

import Select from 'react-select'

import BasePureComponent from 'utils/BasePureComponent'

import './style.scss'

const _renderErrors = (errors) => {
  const _renderError = (error, idx) => <li key={idx}>{error}</li>

  return errors.length ? (
    <ul className="errors-list">
      { errors.map(_renderError) }
    </ul>
  ) : null
}

export default class SelectWrapper extends BasePureComponent {
  render() {
    const {label, errors, ...selectProps} = this.props
    const isAsync = typeof selectProps.loadOptions === 'function'
    const SelectComponent = isAsync ? Select.Async : Select

    const hasErrorsClass = errors.length ? `has-errors` : null

    /**
     * for some reason even when source for options is `loadOptions` func
     * react-select filters options again with specified params
     * so if our request is async we need to override `filterOptions` function
     * to delegate filtering to backend and show whatever it returned!
     * by default ignoreCase and ignoreAccents are false
     */
    selectProps.filterOptions = isAsync ? (options) => options : undefined

    return (
      <div className={`Select-wrapper ${hasErrorsClass}`}>
        {!!label ? <label>{label}</label> : null}
        <SelectComponent
          ref={(select) => this.select = select}
          noResultsText="No se encontraron resultados"
          ignoreCase={false}
          ignoreAccents={false}
          placeholder="Seleccionar"
          {...selectProps}
        />
        {_renderErrors(errors)}
      </div>
    )

  }
}

SelectWrapper.defaultProps = {
  errors: []
}

SelectWrapper.propTypes = {
  label: PropTypes.string,
  errors: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/Select/index.js